import React from 'react';

export const SoundCloud = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
    <path d="M10.5 25.998H9V13.531a6.102 6.102 0 011.5-.875v13.342zm4.5 0h1.5V11.744c-.343.41-.665.847-.931 1.325L15 12.784v13.214zm-3 0h1.5V12.326c-.762-.123-.934-.078-1.5-.016v13.688zm-6 0h1.5V15.15a7.356 7.356 0 00-1.038 2.372L6 17.242v8.756zm-4.5-8.112A4.77 4.77 0 000 21.39a4.77 4.77 0 001.5 3.505v-7.01zm28.319-1.037C29.512 12.465 26.212 9 22.142 9c-1.533 0-2.946.507-4.143 1.355v15.643h13.634c2.41 0 4.366-2.152 4.366-4.8 0-3.45-3.252-5.828-6.181-4.35zM4.5 16.807c-.453-.037-.789-.046-1.5.188v8.792c.669.22.954.213 1.5.213v-9.193z" />
  </svg>
);
